"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
function InsightsGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="h-[400px] animate-pulse bg-muted/50 border-none p-0 gap-0" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-muted-foreground py-12">
        <p>Unable to load insights at this time.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center text-muted-foreground py-12">
        <p>No insights available.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group relative flex flex-col h-full overflow-hidden border-y border-r border-border border-l-[5px] border-l-transparent hover:border-l-secondary transition-all duration-300 shadow-sm hover:shadow-md bg-card rounded-xl p-0 gap-0">
          <div className="relative h-56 w-full overflow-hidden bg-muted shrink-0">
            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580361/img/generic_insight_placeholder.png"} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <Badge className="absolute top-4 left-4 bg-primary text-primary-foreground hover:bg-primary uppercase text-[10px] font-bold tracking-wider px-3 py-1 rounded-sm border-none shadow-sm">
              Insights
            </Badge>
          </div>
          <CardContent className="flex flex-col flex-grow p-6 pt-6">
            <h3 className="text-xl font-bold text-foreground mb-4 font-sans line-clamp-3 leading-snug">
              {post.title}
            </h3>
            <div className="mt-auto pt-4">
              <Link to={post.link || "#"} className="inline-flex items-center gap-2 text-primary font-medium hover:underline text-sm transition-colors">
                Read Case Study
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
export default function StrategicInsights() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query({
    post_type: "post",
    ...wp_query_params
  });
  return <section id="strategic-insights" className="bg-[#f8f8f8] py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6 font-sans tracking-tight">
            Strategic Insights
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Explore our latest case studies and articles on compliance, security, and operational excellence in public administration.
          </p>
        </div>

        <PostsProvider wp_query={wp_query} className="insights-grid-wrapper">
          <InsightsGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}